import React from 'react'
import PropTypes from 'prop-types'
import { concatClasses, RenderAorB, RenderIf } from '../../utils/fns'

const getInputClassName = (classes) => concatClasses('inputGroup', classes)

export const InputGroup = React.forwardRef((props, ref) => {
  const { as: Component, addonBefore, addonAfter, ...inputProps } = props

  return (
    <div className={getInputClassName(inputProps.disabled ? 'inputGroup--disabled' : '')}>
      {RenderIf(
        addonBefore,
        <span className="inputGroup__addon addon--before">{addonBefore}</span>,
      )}
      <Component ref={ref} {...inputProps} />
      {RenderAorB(
        typeof addonAfter === 'string',
        <span className="inputGroup__addon addon--after">{addonAfter}</span>,
        addonAfter,
      )}
    </div>
  )
})

InputGroup.displayName = 'InputGroup'

InputGroup.propTypes = {
  as: PropTypes.string,
  addonBefore: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.arrayOf(PropTypes.element),
  ]),
  addonAfter: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.objectOf(PropTypes.any),
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.arrayOf(PropTypes.element),
  ]),
}

InputGroup.defaultProps = {
  as: 'input',
  type: 'text',
}
